Revolution.Module.extend({
    NAME: "mde.forms", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "closeNavMob", "showBtnExpendTouch");
        //

        //events
        this.initInputFile();

        $('.label-number').closest('label').prev().on('change', this.checkboxesCounter);
        $('.js-uncheck-options').on('click', this.uncheckOptions);

        $('body').on('change', '.js-conditional-radio', this.conditionnalRadio);

        $('body').on('click', '.js-add-form-line', this.addFormLine);
        $('body').on('click', '.js-remove-line', this.removeFormLine);

        $('.js-date').mask('00/00/0000');

        this.initFormWithParsley();

        this.initSelect();
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {
        if ($('.js-custom-select2').length) {
            this.initSelect();
        }
    },

    removeFormLine: function (e) {
        var $obj = $(e.currentTarget);
        $obj.closest('.js-added-line').remove();
    },

    addFormLine: function (e) {
        var $obj = $(e.currentTarget);
        var $parent = $obj.closest('.js-add-form-line-wrapper');
        var templating = $parent.find('[type="text/template"]').html();
        var $wrapper = $parent.find('.js-insert-wrapper');
        var nblines = $wrapper.find('> *').length;
        var renderTemplate = templating.replace(/{i}/g, nblines + 1);

        $wrapper.append(renderTemplate);
        $.applyDataMask();
        Revolution.get("mde.accessible-function").giveTempFocus($wrapper.find('.js-added-line:last-child'));
    },

    conditionnalRadio: function (e) {
        var $obj = $(e.currentTarget);
        var group = $obj.data('fields-group');
        var targets = $obj.data('fields');
        var targetsArray = targets.split(', ');

        $(group).find('.js-conditional').hide();
        $(group).find('.js-conditional').find('[data-required]').removeAttr('required');

        for (i = 0; i < targetsArray.length; i++) {
            var target = targetsArray[i];
            $(target).show();
            $(target).find('[data-required]').attr('required', true);
        }
    },

    initInputFile: function () {
        $('.js-inputfile').each(function (index, el) {
            var $label = $(el).next('label'),
                labelVal = $label.html(),
                $formItem = $label.closest('.form-item');

            $(el).on('change', function (e) {
                var fileName = '';
                if (this.files && this.files.length > 1) {
                    fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                } else {
                    //fileName = e.target.value.split("\"").pop();
                    fileName = e.target.files[0].name;
                }

                if (fileName) {
                    $label.find('.result').text(fileName);
                    $formItem.find('.delete-inputfile').show();
                } else {
                    $label.text(labelVal);
                }
            });
        });
    },
    clearInputFile: function (e) {
        var $obj = $(e.currentTarget);
        $obj.closest('label').prev('[type="file"]').val('');
        $obj.closest('label').find('.result').text('');
        $obj.hide();
    },

    checkboxesCounter: function (e) {

        var $obj = $(e.currentTarget);
        var $label = $(e.currentTarget).next('label');
        var $parent = $obj.closest('.bk-options');
        var nbChecked = $parent.find(':checked').length;

        if (nbChecked > 0) {
            $parent.next('.ta-c').find(':checked').prop('checked', false);
        }

        if ($obj.is(':checked')) {
            $label.find('.label-number').html(nbChecked);
        } else {
            var valDisable = parseInt($label.find('.label-number').html());
            $parent.find(':checked').each(function (index, elem) {
                var val = parseInt($(elem).next('label').find('.label-number').html());
                if (val > valDisable) {
                    $(elem).next('label').find('.label-number').html(val - 1);
                }
            });
        }
    },

    uncheckOptions: function (e) {
        var $obj = $(e.currentTarget);
        $obj.closest('.ta-c').prev('.bk-options').find(':checked').prop('checked', false);
    },

    initFormWithParsley: function () {
        $('.js-form-parsley').each(function (index, el) {
            $(el).parsley({
                errorsContainer: function(parsleyField) {
                    if (parsleyField.$element.closest('.js-webform-checkboxes').length || parsleyField.$element.closest('.js-webform-radios').length) {
                        return parsleyField.$element.closest('.fieldset-wrapper');
                    } else {
                        return parsleyField.$element.closest('.field-wrapper');
                    }
                },
                classHandler: function(parsleyField) {
                    if (parsleyField.$element.closest('.js-webform-checkboxes').length && !parsleyField.$element.closest('.js-webform-checkboxes').hasClass('parsley-error')) {
                        return parsleyField.$element.closest('.js-webform-checkboxes');
                    } else if (parsleyField.$element.closest('.js-webform-radios').length) {
                        return parsleyField.$element.closest('.js-webform-radios');
                    } else {
                        return parsleyField.$element.closest('.parsley-class-handler');
                    }
                }
            });
        })
    },

    initSelect: function () {
        $('.js-custom-select2').each(function (index, el) {
            $(el).on('select2:open', function (e) {
                if($('.bk-banner .banner-content').length) {
                    $('.bk-banner .banner-content').css('z-index', '100');
                }
            });
            $(el).on('select2:close', function (e) {
                if($('.bk-banner .banner-content').length) {
                    $('.bk-banner .banner-content').css('z-index', '2');
                }
            });
            $(el).select2({
                minimumResultsForSearch: Infinity,
                dropdownParent: $(el).parent(),
            });
        })
    }

});
